import { useState } from "react";

export default function useSelect(defaultOptions) {
  const [options, setOptions] = useState(defaultOptions);
  const [selectedOption, setSelectedOption] = useState({
    name: "All",
    value: "",
  });

  function reset() {
    setSelectedOption({ name: "All", value: "" });
  }
  function select(option) {
    setSelectedOption(option);
  }

  return {
    options,
    setOptions,
    select,
    selectedOption,
    reset,
  };
}
